import script from "./PelLoanOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./PelLoanOption.vue?vue&type=script&setup=true&lang=ts"

import "./PelLoanOption.vue?vue&type=style&index=0&id=f878128c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f878128c"]])

export default __exports__